import { Button } from '@/components/ui/Button';

/**
 * Shown when account scaffolding (the `ensure_user_profile` recovery) hasn't
 * completed after a grace period — usually a transient App Check / network
 * failure at signup. Replaces the otherwise-infinite "Setting up your account…"
 * spinner with an error + retry + a way to reach us, so a caregiver is never
 * lost silently. See docs/security-hardening.md ("Cost controls", gap #2).
 */
export function AccountSetupProblem({
  onRetry,
  retrying,
}: {
  onRetry: () => void;
  retrying: boolean;
}) {
  return (
    <div className="flex flex-col items-center gap-4 py-8 text-center">
      <p className="text-sm text-ink-soft">
        We're having trouble finishing your account setup. This is usually
        temporary.
      </p>
      <Button onClick={onRetry} disabled={retrying}>
        {retrying ? 'Trying again…' : 'Try again'}
      </Button>
      <p className="text-xs text-ink-muted">
        Still stuck? Email{' '}
        <a className="underline" href="mailto:hello@remindmevoice.com">
          hello@remindmevoice.com
        </a>{' '}
        and we'll get you set up.
      </p>
    </div>
  );
}
